import "./AboutCard.css";

const AboutCard = () => {
  return (
    <div className="container">
      <p className="paragraph">
        I’m Syreeta, and I have just completed a full-stack web development
        coding bootcamp with the University of Birmingham.
      </p>
      <p className="paragraph">
        After spending the last 7 years working as a primary school teacher, the
        recent pandemic has led to some soul-searching and I have decided to
        begin a career change and move into the world of software engineering!
      </p>
      <p className="paragraph">
        I’m hard-working, driven and have excellent communication skills. I am
        motivated by the challenge coding presents and I’m looking forward to
        transferring my skillset and developing it further.
      </p>
      <p className="paragraph">
        I am currently proficient in HTML, CSS, javaScript, React, MySQL and
        NoSQL databases and Express as you will see when looking at ‘My
        Projects’.
      </p>
    </div>
  );
};

export default AboutCard;
